import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    title: "1. Acceptance of terms",
    body: [
      "By using the Book Away website, mobile app, or partner dashboard (together, the 'Service'), you agree to these Terms of Service. If you do not agree, please do not use the Service.",
    ],
  },
  {
    title: "2. The service",
    body: [
      "Book Away connects clients with beauty and grooming businesses (salons, studios, and independents) for last-minute appointments and cancellations. We are a marketplace — we do not perform the services listed and are not a party to the contract between clients and businesses.",
    ],
  },
  {
    title: "3. Accounts",
    body: [
      "You are responsible for the accuracy of information you provide (such as salon name, owner name and email) and for keeping your credentials confidential.",
      "You must be at least 18 years old to register a business or take a booking.",
    ],
  },
  {
    title: "4. Foundation Membership",
    body: [
      "Foundation membership is limited to the first twenty (20) qualifying businesses per market and grants a lifetime discount on the Platinum tier subject to continuous active status. Book Away reserves the right to verify eligibility and to close applications once spots are filled.",
    ],
  },
  {
    title: "5. Bookings, cancellations & fees",
    body: [
      "Businesses set their own prices, availability, and cancellation policies. Clients agree to those policies at the time of booking.",
      "Membership fees are billed on the schedule shown at signup and are non-refundable except where required by law.",
    ],
  },
  {
    title: "6. Acceptable use",
    body: [
      "You agree not to misuse the Service, including by uploading harmful content, attempting to access data you are not authorised to see, or interfering with the platform's operation.",
    ],
  },
  {
    title: "7. Intellectual property",
    body: [
      "The Book Away name, logo, editorial content, and interface are our intellectual property. Businesses retain rights to their own listings and photography.",
    ],
  },
  {
    title: "8. Limitation of liability",
    body: [
      "To the maximum extent permitted by law, Book Away is not liable for indirect or consequential losses arising from the Service. Nothing in these Terms limits any consumer rights that cannot lawfully be excluded.",
    ],
  },
  {
    title: "9. Changes to these terms",
    body: [
      "We may update these Terms from time to time. Material changes will be communicated by email or in-app notice. Continued use after the update means you accept the revised Terms.",
    ],
  },
  {
    title: "10. Governing law",
    body: [
      "These Terms are governed by the laws of New South Wales, Australia, unless a different jurisdiction is required by law.",
    ],
  },
];

export default function Terms() {
  return <LegalPage kind="terms" sections={SECTIONS} />;
}
